import { getFile } from "../../api/file/getFile";
import { getMySalesOwner } from "../../api/user/getMySalesOwner";
import { messageMySalesOwner } from "../../api/user/messageMySalesOwner";
import APHelpForm, { APHelpFormConfig } from "../../components/APHelpForm";
import ModalContainer from "../../components/ModalContainer";
import { AUTO_UX_PHONE_NUMBER, AUTO_UX_SUPPORT_BIO } from "../../types/App";

const ContactSalesOwner = ({
  onSubmit,
  regardingOpportunityId,
}: {
  onSubmit: () => void;
  regardingOpportunityId?: string;
}) => {
  const salesOwner = getMySalesOwner();
  const { mutateAsync: messageAsync } = messageMySalesOwner({
    mutationOptions: { successAlertMessage: "Message sent. Check email." },
  });

  // Use getFile to fetch the image if photoUrl exists
  const imageSrc = getFile(salesOwner.data?.photoUrl || "", true, {
    disabled: !salesOwner.data?.photoUrl,
  });

  const config: APHelpFormConfig = {
    title: `${salesOwner.data?.firstname || "Our team"} is here to help`,
    bio: salesOwner.data?.biographyExternal ?? AUTO_UX_SUPPORT_BIO,
    phone: salesOwner.data?.preferredPhone ?? AUTO_UX_PHONE_NUMBER,
    callText: `Call ${salesOwner.data?.firstname ?? "Us"}`,
    messageText: `Message ${salesOwner.data?.email ?? ""}`,
    image: !imageSrc.isLoading
      ? imageSrc.data || "/auto-ux-team.png"
      : undefined,
  };

  const _onSubmit = async (message: string) => {
    messageAsync({
      message: message,
      regardingOpportunityId: regardingOpportunityId || undefined,
      pageUrl: window.location.pathname,
    });

    onSubmit();
  };

  return (
    <ModalContainer loading={salesOwner.isLoading} title={undefined}>
      {salesOwner.isSuccess && (
        <APHelpForm config={config} onSubmit={_onSubmit} />
      )}
    </ModalContainer>
  );
};

export default ContactSalesOwner;
